// extracted by mini-css-extract-plugin
module.exports = {"listHeader":"r5yLFyLg","listHeaderText":"_3xHCIdCl","listContent":"_192tQQjU","addToEmailButton":"_1ZrEsXxK","saveChangeButton":"_35hP6wzt"};